import { UserManagerSettings, WebStorageStateStore } from "oidc-client-ts";

const authority = import.meta.env.VITE_OIDC_AUTHORITY;
const client_id = import.meta.env.VITE_OIDC_CLIENT_ID;
const redirect_uri = import.meta.env.VITE_OIDC_REDIRECT_URI;
const post_logout_redirect_uri = import.meta.env.VITE_OIDC_LOGOUT_REDIRECT_URI;
const end_session_endpoint = import.meta.env.VITE_OIDC_END_SESSION;
const fallbackLoginUrl = import.meta.env.VITE_OIDC_FALLBACK_LOGIN_URL;
const silent_redirect_uri = import.meta.env.VITE_OIDC_SILENT_RENEW_URI;

const requestedScope = import.meta.env.VITE_OIDC_SCOPE || "openid profile";

export const oidcConfig: UserManagerSettings = {
  authority,
  client_id,
  redirect_uri,
  post_logout_redirect_uri,
  silent_redirect_uri,
  response_type: import.meta.env.VITE_OIDC_RESPONSE_TYPE || "code",
  scope: requestedScope,

  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  stateStore: new WebStorageStateStore({ store: window.sessionStorage }),

  // We handle renew ourselves. Do not let oidc-client-ts also auto-renew
  // or multiple refresh-token requests can race in refresh-token-rotation flows.
  automaticSilentRenew: false,
  filterProtocolClaims: true,
  loadUserInfo: true,

  refreshTokenAllowedScope: "openid profile",

  metadata: {
    issuer: authority,
    authorization_endpoint: `${authority}/authorize`,
    token_endpoint: `${authority}/token`,
    userinfo_endpoint: `${authority}/userinfo`,
    jwks_uri: `${authority}/jwks`,
    end_session_endpoint: end_session_endpoint,
    revocation_endpoint: `${authority}/revoke`,
    introspection_endpoint: `${authority}/introspect`,
  },
};

export const fallbackConfig = {
  siteMinderLoginRedirectUrl: fallbackLoginUrl,
};